import React from 'react';
import { Header } from '../components/shared/Header';
import { Hero } from '../components/landing/Hero';
import { StatsSection } from '../components/landing/StatsSection';
import { FeaturesGrid } from '../components/landing/FeaturesGrid';
import { HowItWorks } from '../components/landing/HowItWorks';
import { PricingCards } from '../components/landing/PricingCards';
import { FAQ } from '../components/landing/FAQ';
import { FinalCTA } from '../components/landing/FinalCTA';
import { Footer } from '../components/landing/Footer';

export const LandingPage: React.FC = () => {
  return (
    <div className="page-shell">
      <Header />
      <main>
        <Hero />
        <StatsSection />
        <FeaturesGrid />
        <HowItWorks />
        <PricingCards />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
};

export default LandingPage;
